import React from 'react';


function SelectPais(props){
    return(props.paises.map(pais => <option key={pais.id} value={pais.id}>{pais.nombre}</option>))
}

export default SelectPais;